import React, { useEffect, useState } from "react";
import Dialog from "./Dialog";
import { motion, AnimatePresence } from "framer-motion";

import DialogButton from "../../assets/images/New folder/rules_recharge2.png";
import giftBackground from "../../assets/images/New folder/container 2.png";

import unlocked from "../../assets/images/New folder/unlocked 1.png";
import rank1 from "../../assets/images/New folder/rnk1 1.png";
import rank2 from "../../assets/images/New folder/rnk2 1.png";
import rank3 from "../../assets/images/New folder/rnk3 1.png";

import desctive from "../../assets/images/New folder/desctive 1.png";
import tabBar from "../../assets/images/New folder/inactive 1.png";
import activeTabBar from "../../assets/images/New folder/active 3.png";
import imageRing from "../../assets/images/New folder/ic_golden_ring 1.png";
import fallbackImage from "../../assets/icons/gift-box 1.png";
import fallbackImage1 from "../../assets/icons/selected_male.png";
import coins from "../../assets/images/New folder/coin 3 (1).png";

import { useTranslation } from "react-i18next";
import TimerComponent from "./TimerComponent";
const Design = ({ weeklyData1, weeklyData2, setFlag, flag, weeklyRating }) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("tab1");

  const [isLoading, setIsLoading] = useState(false);
  const openDialog = () => setIsDialogOpen(true);
  const closeDialog = () => setIsDialogOpen(false);
  const urlParams = new URLSearchParams(window.location.search);
  const token = urlParams.get("token");
  const [imageErrors, setImageErrors] = useState({});
  const imageBaseUrl = "https://media.smolivechat.com/";

  // Handle image error by updating the imageErrors state
  const handleError = (itemId) => {
    setImageErrors((prevState) => ({
      ...prevState,
      [itemId]: true, // Mark this item image as failed to load
    }));
  };
  const { t } = useTranslation();
  const handleReceived = async (id) => {
    setIsLoading(true);
    try {
      const response = await fetch(
        "https://new.smolivechat.com/api/charge-events/received-rewards",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`, // Use backticks for token interpolation
          },
          body: JSON.stringify({
            target_id: id, // Ensure this is correct
          }),
        },
      );
      setFlag(!flag);
      setIsLoading(false);

      // Check for a successful response
      if (!response.ok) {
        console.error("Response Status:", response.status);
        throw new Error("Network response was not ok");
      }

      // Parse and return the response data
      const data = await response.json();
      return data; // Return the data received from the API
    } catch (error) {
      console.error("Error details:", error); // Log detailed error message
      throw new Error(error.message); // Rethrow the error if needed
    }
  };
  const ProgressBar = ({ remaining, value, userCoins = 0 }) => {
    if (value == null) return null;

    const percentage = Math.min(Math.max(remaining * 100, 0), 100);
    const left = Math.max(value - userCoins, 0);

    return (
      <div className="w-[90%] mx-auto my-1">
        <div className="flex flex-row justify-between items-end mb-1 font-cairo font-semibold text-[12px] leading-[16px] [text-shadow:0_1px_2px_rgba(0,0,0,0.6)]">
          <span className="text-[#FECE60]">
            {t("Recharges")} {Number(value).toLocaleString()} {t("Coins")}
          </span>
          {left > 0 && (
            <span className="text-[#FCF89F] font-bold">
              {t("Left")} {left.toLocaleString()}
            </span>
          )}
        </div>
        <div className="h-[14px] p-[2px] rounded-full bg-gradient-to-b from-[#F2DA7A] via-[#D27A22] to-[#8C5722] shadow-[0_0_6px_rgba(250,215,78,0.35)]">
          <div className="h-full rounded-full overflow-hidden bg-[#3A0A05] shadow-[inset_0_1px_3px_rgba(0,0,0,0.8)]">
            <div
              className="h-full rounded-full bg-gradient-to-r from-[#D27A22] via-[#F6A100] to-[#FCF89F] shadow-[0_0_6px_rgba(252,248,159,0.8)] transition-all duration-500"
              style={{
                width: `${percentage}%`,
                minWidth: percentage > 0 ? 8 : 0,
              }}
            />
          </div>
        </div>
      </div>
    );
  };
  // Enhanced ScoreBadge component
  const ScoreBadge = ({ score }) => (
    <div className="flex items-center gap-1  px-2 py-1 rounded-full    ">
      <img src={coins} alt="coin" className="  " />
      <span className="text-[#FCF89F] font-bold text-[16px] sm:text-base drop-shadow-lg">
        {parseInt(score)?.toLocaleString() || "0"}
      </span>
    </div>
  );

  // Enhanced Avatar component
  const AvatarImage = ({ imageUrl, size = "w-14 h-14 ", className = "" }) => (
    <div className="relative group">
      <img
        src={imageRing}
        className={` w-12  h-12  z-40 absolute top-0 left-0 rounded-full   shadow-xl   object-cover transform group-hover:scale-110 transition-transform duration-300 ${className}`}
        alt="avatar"
      />{" "}
      <img
        src={
          imageErrors[imageUrl] ? fallbackImage1 : `${imageBaseUrl}${imageUrl}`
        }
        onError={() => handleError(imageUrl)}
        className={`${size} rounded-full   shadow-xl relative z-10 object-cover transform group-hover:scale-110 transition-transform duration-300 ${className}`}
        alt="avatar"
      />
    </div>
  );

  const renderTabContent = () => {
    if (activeTab === "tab1") {
      return (
        <motion.div
          key="tab1"
          initial={{ opacity: 0, x: 20 }}
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0, x: -20 }}
          transition={{ duration: 0.3 }}
          className="px-3 pb-32"
        >
          <div className="relative w-full  ">
            <div className="absolute inset-0   bg-contain bg-center bg-no-repeat opacity-50 z-0"></div>
            {weeklyData2 ? (
              weeklyData2?.map((tier, index) => (
                <motion.div
                  className="relative"
                  key={tier.id}
                  initial={{ opacity: 0, y: 30 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: index * 0.1, duration: 0.4 }}
                >
                  <img
                    src={giftBackground}
                    alt="ring"
                    className="w-full h-auto mx-auto"
                  />
                  <p className="absolute font-bold gradientText22 top-[10px] left-[50%] transform -translate-x-1/2 -translate-y-[34%]  text-[20px] leading-none tracking-normal text-center">
                    {t("$ ")} {tier.value}
                    {t(" $")}
                  </p>

                  <div className="absolute h-[85%] flex flex-col justify-between top-[65px] w-full">
                    <div
                      className={`  h-[95%] overflow-y-scroll  w-[90%] mx-auto ${
                        tier.rewards.length > 3 ? "" : "justify-center"
                      }   `}
                    >
                      <div className="flex flex-row  gap-1 items-center flex-wrap  justify-center mx-auto">
                        {tier.rewards ? (
                          tier.rewards?.map((item, rewardIndex) => (
                            <motion.div
                              className="w-[31%] h-[150px]"
                              key={rewardIndex}
                              initial={{ opacity: 0, scale: 0.8 }}
                              animate={{ opacity: 1, scale: 1 }}
                              transition={{ delay: rewardIndex * 0.06 }}
                            >
                              <div className="w-[80px] boderBackground mx-auto  ">
                                <img
                                  src={
                                    imageErrors[item.image]
                                      ? fallbackImage
                                      : `${imageBaseUrl}/${item.image}`
                                  }
                                  onError={() => handleError(item.image)}
                                  className="w-[60px] h-[60px] relative left-[18%] top-[19%] rounded-full"
                                  alt={item.name}
                                />
                              </div>
                              <p className="text-[#fece60] text-center font-medium text-xs">
                                {item?.name}
                              </p>
                            </motion.div>
                          ))
                        ) : (
                          <p className="text-xs font-medium text-[#FFEE40] text-center py-8">
                            {t("no data available")}
                          </p>
                        )}
                      </div>
                      {tier.top_receivers?.length > 0 &&
                        (() => {
                          // build a receivers array with the 2nd item duplicated
                          const receivers = [
                            ...tier.top_receivers.slice(0, 2), // first two
                            tier.top_receivers[1], // duplicate 2nd
                            ...tier.top_receivers.slice(2), // rest
                          ];

                          return (
                            <div className="flex flex-row justify-start gap-1 items-center mx-auto  w-[100%]">
                              {tier.top_receivers.map((receiver, idx) => {
                                // pick the right badge (fallback if >3)

                                const isFirst = idx === 1;

                                return (
                                  <motion.div
                                    key={`${receiver.id}-${idx}`} // use composite key so React won’t complain
                                    className="relative flex flex-col items-center"
                                    initial={{ opacity: 0, scale: 0, y: 10 }}
                                    animate={{
                                      opacity: 1,
                                      scale: isFirst ? 1.1 : 1,
                                      y: isFirst ? -16 : 0,
                                    }}
                                    transition={{
                                      delay: idx * 0.08,
                                      type: "spring",
                                      stiffness: 260,
                                      damping: 18,
                                    }}
                                  >
                                    {/* Profile image */}
                                    <img
                                      src={`${imageBaseUrl}/${receiver.img}`}
                                      onError={() => handleError(receiver.img)}
                                      alt={receiver.name}
                                      className="w-[70px] z-10 h-[70px] rounded-full object-cover absolute
                         top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2
                         border-2 border-white shadow-md"
                                    />
                                  </motion.div>
                                );
                              })}
                            </div>
                          );
                        })()}
                    </div>
                    <ProgressBar
                      remaining={tier.remaining}
                      value={tier.value}
                      userCoins={tier.user_coins}
                    />
                    {/* Buttons */}
                    {tier?.is_received ? (
                      <button
                        disabled
                        className="mx-auto w-32 py-2 relative rounded-full text-sm font-bold "
                      >
                        <img
                          src={unlocked}
                          alt="unlocked"
                          className=" w-full md:[200px] h-[39px]"
                        />
                        <p className="absolute font-cairo font-bold top-[47%] left-[50%] transform -translate-x-1/2 -translate-y-1/2 gradientText text-base md:text-3xl  leading-[48.32px] text-center">
                          {t("Received")}
                        </p>
                      </button>
                    ) : tier?.can_received ? (
                      <motion.button
                        onClick={() => handleReceived(tier.id)}
                        disabled={isLoading}
                        whileHover={{ scale: 1.05 }}
                        whileTap={{ scale: 0.92 }}
                        className={`mx-auto w-32 relative py-2 rounded-full text-sm font-bold
      ${isLoading ? "opacity-70 cursor-wait" : "animate-pulse"}`}
                      >
                        <img
                          src={desctive}
                          alt="desctive"
                          className=" w-full md:[200px] h-[39px]"
                        />
                        <p className="absolute font-cairo font-bold top-[47%] left-[50%] transform -translate-x-1/2 -translate-y-1/2 gradientText text-base md:text-3xl  leading-[48.32px] text-center">
                          {isLoading ? t("Loading...") : t("Collect")}
                        </p>
                      </motion.button>
                    ) : (
                      <button
                        disabled
                        className="mx-auto w-32 py-2 relative rounded-full text-sm font-bold text-gray-500 
       "
                      >
                        <img
                          src={desctive}
                          alt="desctive"
                          className=" w-full md:[200px] h-[39px]"
                        />
                        <p className="absolute font-cairo font-bold top-[47%] left-[50%] transform -translate-x-1/2 -translate-y-1/2 gradientText text-base md:text-3xl  leading-[48.32px] text-center">
                          {t("Receive")}
                        </p>
                      </button>
                    )}
                  </div>
                </motion.div>
              ))
            ) : (
              //gray if it true  gold and shemer if it false
              <p className="text-xs font-medium text-[#FFEE40] text-center py-8">
                {t("no data available")}
              </p>
            )}
          </div>
        </motion.div>
      );
    } else if (activeTab === "tab2") {
      return (
        <motion.div
          key="tab2"
          initial={{ opacity: 0, x: 20 }}
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0, x: -20 }}
          transition={{ duration: 0.3 }}
          className="px-3 pb-32"
        >
          {/* Top winner podium */}
          {weeklyRating &&
            weeklyRating[0] &&
            weeklyRating[1] &&
            weeklyRating[2] && (
              <motion.div
                initial={{ opacity: 0, y: -20 }}
                animate={{ opacity: 1, y: 0 }}
                className="relative pt-5 px-3 bgBenefitRank min-h-[39rem] mb-8"
              >
                <div className="relative  w-full h-full">
                  <img
                    src={rank1}
                    alt="rank1"
                    className="w-[83%] mx-auto relative z-30 h-full object-contain"
                  />
                  <img
                    src={
                      imageErrors[weeklyRating[0]?.profile?.image]
                        ? fallbackImage1
                        : `${imageBaseUrl}${weeklyRating[0]?.profile?.image}`
                    }
                    alt="rank1"
                    className="w-20 h-20 z-10 absolute top-[14%] left-1/2 -translate-x-1/2 rounded-full    object-contain"
                  />
                  <p className="gradientTextGold  absolute top-[59%] left-1/2 -translate-x-1/2  z-50 font-bold text-base sm:text-sm text-center truncate max-w-[80px] sm:max-w-[100px]">
                    {weeklyRating[0]?.name}
                  </p>
                  <div className="absolute top-[75%] left-1/2 -translate-x-1/2 z-50 flex items-center gap-1">
                    <span className="gradientTextGold font-bold text-sm sm:text-base drop-shadow-lg">
                      {parseInt(
                        weeklyRating[0]?.total_charges,
                      )?.toLocaleString() || "0"}
                    </span>
                    <img
                      src={coins}
                      alt="coin"
                      className="w-6 h-6 sm:w-5 sm:h-5"
                    />
                  </div>
                </div>
                <div className="flex flex-row justify-between gap-2 mb-8">
                  <div className="relative w-full h-full">
                    <img
                      src={rank2}
                      alt="rank2"
                      className="w-full relative z-30 h-full object-contain"
                    />
                    <img
                      src={
                        imageErrors[weeklyRating[1]?.profile?.image]
                          ? fallbackImage1
                          : `${imageBaseUrl}${weeklyRating[1]?.profile?.image}`
                      }
                      alt="rank1"
                      className="w-16 h-16 z-10 absolute top-[15%] left-1/2 -translate-x-1/2 rounded-full    object-contain"
                    />
                    <p className="gradientTextGold  absolute top-[59%] left-1/2 -translate-x-1/2  z-50 font-bold text-base sm:text-sm text-center truncate max-w-[80px] sm:max-w-[100px]">
                      {weeklyRating[1]?.name}
                    </p>
                    <div className="absolute top-[75%] left-[44%] -translate-x-1/2 z-50 flex items-center gap-1">
                      <span className="gradientTextGold font-bold text-sm sm:text-base drop-shadow-lg">
                        {parseInt(
                          weeklyRating[1]?.total_charges,
                        )?.toLocaleString() || "0"}
                      </span>
                      <img
                        src={coins}
                        alt="coin"
                        className="w-6 h-6 sm:w-5 sm:h-5"
                      />
                    </div>
                  </div>
                  <div className="relative w-full h-full">
                    <img
                      src={rank3}
                      alt="rank3"
                      className="w-full relative z-30 h-full object-contain"
                    />
                    <img
                      src={
                        imageErrors[weeklyRating[2]?.profile?.image]
                          ? fallbackImage1
                          : `${imageBaseUrl}${weeklyRating[2]?.profile?.image}`
                      }
                      alt="rank1"
                      className="w-16 h-16 z-10 absolute top-[15%] left-1/2 -translate-x-1/2 rounded-full    object-contain"
                    />
                    <p className="gradientTextGold  absolute top-[59%] left-1/2 -translate-x-1/2  z-50 font-bold text-base sm:text-sm text-center truncate max-w-[80px] sm:max-w-[100px]">
                      {weeklyRating[2]?.name}
                    </p>
                    <div className="absolute top-[75%] left-[44%] -translate-x-1/2 z-50 flex items-center gap-1">
                      <span className="gradientTextGold font-bold text-base sm:text-base drop-shadow-lg">
                        {parseInt(
                          weeklyRating[2]?.total_charges,
                        )?.toLocaleString() || "0"}
                      </span>
                      <img
                        src={coins}
                        alt="coin"
                        className="w-6 h-6 sm:w-5 sm:h-5"
                      />
                    </div>
                  </div>{" "}
                </div>
              </motion.div>
            )}

          {/* Rankings list */}
          <div className="space-y-2  ">
            {weeklyRating &&
              weeklyRating.slice(3).map((item, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, x: -20 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ delay: index * 0.05 }}
                  className="flex items-center gap-3 px-5 bgRank"
                >
                  <div className="w-8 flex justify-center">
                    <span className="text-[#FCF89F] font-bold">
                      #{index + 4}
                    </span>
                  </div>

                  <AvatarImage
                    imageUrl={item?.profile?.image}
                    size="w-12 h-12 "
                  />

                  <div className="flex-1 flex items-center justify-between">
                    <p className="text-[#FCF89F] font-medium text-[20px] sm:text-sm truncate max-w-[80px] sm:max-w-[100px]">
                      {item?.name}
                    </p>
                    <ScoreBadge score={item?.total_charges} />
                  </div>
                </motion.div>
              ))}
          </div>
        </motion.div>
      );
    }
  };
  return (
    <div className="bg-[#1A0A04]   relative overflow-hidden">
      <div className="Benefit ">
        <Dialog
          isOpen={isDialogOpen}
          closeDialog={closeDialog}
          description={weeklyData1?.role}
        />
        <div className="relative w-full h-[35vh]   ">
          <div className="absolute top-[116%] z-[9999] right-0">
            <div
              onClick={openDialog}
              className="relative inline-block cursor-pointer"
            >
              <img
                src={DialogButton}
                alt="rules"
                className=" w-[86px] md:[200px] h-[60px]"
              />
              <p className="absolute font-cairo font-bold top-[47%] left-[68%] transform -translate-x-1/2 -translate-y-1/2 gradientText text-base md:text-3xl  leading-[48.32px] text-center">
                {t("Rules")}
              </p>
            </div>
          </div>
        </div>
        {/* <div className="relative w-full top-[-3%]  ">
          <img
            src={cp_full1}
            alt="background "
            className="h-[150px] mx-auto w-[300px]"
          />
        </div>{" "} */}
        {/* <div className=" relative top-[-14%] mx-auto w-full h-[50%]">
          <img
            src={"https://media.smolivechat.com/event_media/most_charge_bg.png"}
            alt="background "
            className="h-[307px] mx-auto w-[318px]"
          />{" "}
          <img
            src={
              imageErrors[weeklyData1?.top_charger?.avatar]
                ? fallbackImage1
                : `${imageBaseUrl}/${weeklyData1?.top_charger?.avatar}`
            }
            onError={() => handleError(weeklyData1?.top_charger?.avatar)}
            className="w-[125px] absolute BenefitFadeIn h-[125px] sm:left-[148px] xss:left-[132px] xs:left-[119px]  top-[103px]  mx-auto  rounded-full"
            alt={weeklyData1?.top_charger?.name}
          />{" "}
        </div>{" "} */}
      </div>
      <div className="relative  -mt-40 ">
        {weeklyData1?.remainingTime ? (
          <TimerComponent initialTime={weeklyData1?.remainingTime} />
        ) : null}{" "}
      </div>

      {/* Enhanced Tabs */}
      <div className="flex justify-center gap-2 px-4 mb-6 mt-2">
        {[
          { id: "tab1", label: t("Reward") },
          { id: "tab2", label: t("Monthly") },
        ].map((tab) => (
          <motion.button
            key={tab.id}
            whileTap={{ scale: 0.95 }}
            onClick={() => setActiveTab(tab.id)}
            className="relative flex-1 max-w-[120px] group"
          >
            <motion.img
              whileHover={{ scale: 1.05 }}
              src={activeTab === tab.id ? activeTabBar : tabBar}
              alt={tab.label}
              className="w-[120px] h-[55px] drop-shadow-lg"
            />
            <span
              className={`absolute inset-0 flex items-center justify-center text-xl leading-none tracking-normal text-center ${
                activeTab === tab.id
                  ? "font-semibold text-[#3F0A00]"
                  : "font-medium text-[#FFB77D99] group-hover:text-white/80 transition-colors"
              }`}
            >
              {tab.label}
            </span>
          </motion.button>
        ))}
      </div>
      {/* Tab Content */}
      <AnimatePresence mode="wait">{renderTabContent()}</AnimatePresence>
    </div>
  );
};

export default Design;
